module.exports = __webpack_public_path__ + "img/f295593.jpg";